import { fetcher } from "utils";

export const get__claim_prepare_notice = () => fetcher.get(`/members/order_products/claim_prepare`);
